import {EnvironmentProvider} from 'providers/EnvironmentProvider'
import {Queries} from 'providers/Queries'
import {ResultProvider} from 'providers/ResultProvider'
import {Theme} from 'providers/Theme'
import {View} from './View'

export const Order = () => {
  return (
    <EnvironmentProvider>
      <Theme>
        <ResultProvider>
          <Queries>
            <View />
          </Queries>
        </ResultProvider>
      </Theme>
    </EnvironmentProvider>
  )
}
